
export default class path {

    static baseUrl = "https://k2.piaic.org";
    //static baseUrl = "http://localhost:3001";

    static LOGIN = path.baseUrl + "/authenticate";

    static UPDATE = path.baseUrl + "/api/rest/user/";

    static QUIZ = path.baseUrl + "/api/rest/quiztaker";

}



// WEBPACK FOOTER //
// ./src/config/path.js